(function () {
  const selectors = {
    root: '[data-cirkul-pdp]',
    state: '.cirkul-pdp__state',
    optionButton: '[data-option-button]',
    price: '[data-price-text]',
    comparePrice: '[data-compare-price]',
    addLabel: '[data-add-label]',
    quantityValue: '[data-quantity-value]',
    quantityInput: '[data-quantity-input]',
    quantityButton: '[data-quantity-button]',
    variantInput: '[data-variant-input]',
    addButton: '[data-add-button]',
    accordionToggle: '[data-accordion-toggle]',
    purchaseInput: '[data-purchase-input]',
    mediaTrack: '[data-media-track]',
    mediaDot: '.cirkul-pdp__media-dot',
  };

  const knownColors = [
    'white', 'black', 'blue', 'green', 'gray', 'grey', 'navy', 'orange', 'pink',
    'purple', 'red', 'rose', 'gold', 'apricot', 'chameleon', 'ranger', 'raindrop',
    'midnight', 'fog', 'eucalyptus', 'cherry', 'blossom', 'lilac', 'carbon',
    'brink', 'pearl', 'snow', 'blush', 'steel', 'matte', 'frosted', 'camo'
  ];

  const ignoredTokens = new Set([
    'us', 'ca', 'canada', 'default', 'title', 'and', 'with', 'for', 'the', 'plus'
  ]);

  function formatMoney(cents) {
    return `$${(Number(cents || 0) / 100).toFixed(2)}`;
  }

  function updateButtonLabel(root) {
    root.querySelectorAll(selectors.addLabel).forEach((label) => {
      label.textContent = 'Add to Cart';
    });
  }

  function updatePrice(root, variant) {
    root.querySelectorAll(selectors.price).forEach((node) => {
      node.textContent = formatMoney(variant.price);
    });

    root.querySelectorAll(selectors.comparePrice).forEach((node) => {
      if (variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price)) {
        node.hidden = false;
        node.textContent = formatMoney(variant.compare_at_price);
      } else {
        node.hidden = true;
        node.textContent = '';
      }
    });

    updateButtonLabel(root);
  }

  function syncVariantInputs(root, variantId) {
    root.querySelectorAll(selectors.variantInput).forEach((input) => {
      input.value = variantId;
    });
  }

  function syncQuantity(root, quantity) {
    root.querySelectorAll(selectors.quantityInput).forEach((input) => {
      input.value = quantity;
    });

    root.querySelectorAll(selectors.quantityValue).forEach((node) => {
      node.textContent = quantity;
    });
  }

  function syncBuyRowLayout(root) {
    const row = root.querySelector('.cirkul-pdp__buy-row');
    const qty = root.querySelector('.cirkul-pdp__qty');
    const atc = root.querySelector('.cirkul-pdp__atc');
    if (!row || !qty || !atc) return;

    row.style.flexWrap = 'nowrap';
    row.style.justifyContent = 'flex-start';
    row.style.alignItems = 'center';
    row.style.gap = window.innerWidth <= 749 ? '12px' : '14px';

    qty.style.flex = '0 0 115px';
    qty.style.marginLeft = '0';

    atc.style.width = 'auto';
    atc.style.minWidth = '0';
    atc.style.flex = '1 1 auto';
  }

  function findVariant(variants, optionGroups) {
    return variants.find((variant) => optionGroups.every((group, index) => variant.options[index] === group.value));
  }

  function updateOptionButtons(root, optionGroups) {
    root.querySelectorAll(selectors.optionButton).forEach((button) => {
      const optionIndex = Number(button.getAttribute('data-option-index'));
      const optionValue = button.getAttribute('data-option-value');
      const selected = optionGroups[optionIndex] && optionGroups[optionIndex].value === optionValue;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
  }

  function initMedia(root) {
    const track = root.querySelector(selectors.mediaTrack);
    const dots = Array.from(root.querySelectorAll(selectors.mediaDot));
    if (!track) return;

    const slides = Array.from(track.children);
    if (!slides.length) return;

    let index = 0;

    function render() {
      track.style.transform = `translate3d(${-100 * index}%, 0, 0)`;
      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === index);
      });
    }

    function setIndex(nextIndex) {
      index = Math.max(0, Math.min(nextIndex, slides.length - 1));
      render();
    }

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        setIndex(Number(dot.getAttribute('data-media-target')) || 0);
      });
    });

    let startX = null;
    track.addEventListener('touchstart', (event) => {
      startX = event.changedTouches[0].clientX;
    }, { passive: true });

    track.addEventListener('touchend', (event) => {
      if (startX == null) return;
      const deltaX = event.changedTouches[0].clientX - startX;
      if (Math.abs(deltaX) > 40) {
        if (deltaX < 0 && index < slides.length - 1) setIndex(index + 1);
        if (deltaX > 0 && index > 0) setIndex(index - 1);
      }
      startX = null;
    }, { passive: true });

    root.__cirkulMedia = { setIndex, slides };
    render();
  }

  function normalizeMediaId(value) {
    if (value == null) return '';
    return String(value).replace(/^gid:\/\/shopify\/[^/]+\//, '');
  }

  function normalizeText(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[™®]/g, '')
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function compactText(value) {
    return normalizeText(value).replace(/\s+/g, '');
  }

  function filenameFromSrc(src) {
    try {
      const url = new URL(src, window.location.origin);
      const lastPart = url.pathname.split('/').pop() || '';
      return lastPart.replace(/\.[a-z0-9]+$/i, '');
    } catch {
      const cleaned = String(src || '').split('?')[0];
      const lastPart = cleaned.split('/').pop() || '';
      return lastPart.replace(/\.[a-z0-9]+$/i, '');
    }
  }

  function buildMediaCandidates(root) {
    const byId = new Map();
    root.querySelectorAll('[data-media-id]').forEach((node) => {
      const mediaId = normalizeMediaId(node.getAttribute('data-media-id'));
      const img = node.querySelector('img');
      if (!mediaId || !img || byId.has(mediaId)) return;
      const src =
        node.getAttribute('data-media-src') ||
        img.currentSrc ||
        img.getAttribute('src') ||
        '';
      const file = filenameFromSrc(src);
      const normalized = normalizeText(file);
      byId.set(mediaId, {
        id: mediaId,
        src,
        alt: node.getAttribute('data-media-alt') || img.getAttribute('alt') || '',
        file,
        compact: compactText(file),
        tokens: normalized.split(/\s+/).filter(Boolean),
      });
    });
    return Array.from(byId.values());
  }

  function buildVariantDescriptor(variant) {
    const texts = [variant?.title, ...(variant?.options || [])].filter(Boolean);
    const phrases = new Set();
    const tokens = new Set();
    const colors = [];

    texts.forEach((text) => {
      const normalized = normalizeText(text);
      const compact = compactText(text);
      if (compact) phrases.add(compact);

      if (/matte black/.test(normalized)) phrases.add('matteblack');
      if (/matte blue/.test(normalized)) phrases.add('matteblue');
      if (/matte purple/.test(normalized)) phrases.add('mattepurple');
      if (/rose gold/.test(normalized)) phrases.add('rosegold');
      if (/midnight blue/.test(normalized)) phrases.add('midnightblue');
      if (/cherry blossom/.test(normalized)) phrases.add('cherryblossom');
      if (/blush pink/.test(normalized)) phrases.add('blushpink');
      if (/stainless steel/.test(normalized)) phrases.add('steel');

      const packMatch = normalized.match(/(\d+)\s*pack/);
      if (packMatch) {
        phrases.add(`${packMatch[1]}pack`);
        phrases.add(`${packMatch[1]}pk`);
        tokens.add(packMatch[1]);
      }

      const cartridgeMatch = normalized.match(/(\d+)\s*cartridges?/);
      if (cartridgeMatch) {
        phrases.add(`${cartridgeMatch[1]}cartridges`);
        phrases.add(`${cartridgeMatch[1]}c`);
        tokens.add(cartridgeMatch[1]);
      }

      normalized.split(/\s+/).forEach((token) => {
        if (!token || ignoredTokens.has(token)) return;
        tokens.add(token);
        if (knownColors.includes(token) && !colors.includes(token)) {
          colors.push(token);
        }
      });
    });

    const rawTitle = normalizeText(variant?.title || '');
    const pairStartsWhite = /^white and /.test(rawTitle);
    const pairEndsWhite = / and white$/.test(rawTitle);

    return {
      phrases: Array.from(phrases),
      tokens: Array.from(tokens),
      colors,
      pairStartsWhite,
      pairEndsWhite,
      compactTitle: compactText(variant?.title || ''),
    };
  }

  function inferMediaId(root, variant) {
    const candidates = buildMediaCandidates(root);
    if (!candidates.length || !variant) return '';

    const descriptor = buildVariantDescriptor(variant);
    let best = null;

    candidates.forEach((candidate) => {
      let score = 0;

      descriptor.phrases.forEach((phrase) => {
        if (!phrase) return;
        if (candidate.compact.includes(phrase)) {
          score += 18 + Math.min(phrase.length, 12);
        }
      });

      descriptor.tokens.forEach((token) => {
        if (!token) return;
        if (candidate.tokens.includes(token) || candidate.compact.includes(token)) {
          score += 8;
        }
      });

      if (descriptor.colors.length === 1) {
        if (candidate.tokens.includes(descriptor.colors[0]) || candidate.compact.includes(descriptor.colors[0])) {
          score += 12;
        }
      }

      if (descriptor.colors.length >= 2) {
        const orderedPair = `${descriptor.colors[0]}${descriptor.colors[1]}`;
        const reversePair = `${descriptor.colors[1]}${descriptor.colors[0]}`;
        if (candidate.compact.includes(orderedPair)) score += 34;
        if (candidate.compact.includes(reversePair)) score += 12;
      }

      if (descriptor.pairStartsWhite && descriptor.colors[1]) {
        if (candidate.tokens.includes(descriptor.colors[1]) && !candidate.tokens.includes('white')) {
          score += 28;
        }
      }

      if (descriptor.pairEndsWhite && descriptor.colors[0]) {
        if (candidate.compact.includes(`${descriptor.colors[0]}white`)) {
          score += 28;
        }
      }

      if (descriptor.compactTitle && candidate.compact.includes(descriptor.compactTitle)) {
        score += 40;
      }

      knownColors.forEach((color) => {
        if (!descriptor.colors.includes(color) && candidate.tokens.includes(color)) {
          score -= 2;
        }
      });

      if (!best || score > best.score) {
        best = { id: candidate.id, score };
      }
    });

    return best && best.score > 0 ? best.id : '';
  }

  function updateVariantMedia(root, variant, state) {
    if (!variant) return;
    const mappedMediaId = state?.variantMediaMap?.[String(variant.id)] || inferMediaId(root, variant);
    const mediaId = normalizeMediaId(
      mappedMediaId ||
      variant.featured_media?.id ||
      variant.featured_image?.id ||
      variant.image_id ||
      variant.featured_media_id
    );

    if (!mediaId) return;

    const desktopHero = root.querySelector('.cirkul-pdp__desktop-hero img');
    const desktopSourceNode =
      root.querySelector(`.cirkul-pdp__desktop-hero[data-media-id="${mediaId}"]`) ||
      root.querySelector(`.cirkul-pdp__desktop-tile[data-media-id="${mediaId}"]`) ||
      root.querySelector(`.cirkul-pdp__mobile-slide[data-media-id="${mediaId}"]`) ||
      root.querySelector(`[data-media-id="${mediaId}"]`);
    const desktopSource = desktopSourceNode?.querySelector('img');
    if (desktopHero && desktopSource) {
      const nextSrc =
        desktopSourceNode?.getAttribute('data-media-src') ||
        desktopSource.currentSrc ||
        desktopSource.getAttribute('src') ||
        desktopHero.src;
      desktopHero.src = nextSrc;
      if (desktopSource.getAttribute('srcset')) {
        desktopHero.srcset = desktopSource.getAttribute('srcset');
      } else {
        desktopHero.removeAttribute('srcset');
      }
      desktopHero.alt =
        desktopSourceNode?.getAttribute('data-media-alt') ||
        desktopSource.getAttribute('alt') ||
        desktopHero.alt;
    }

    const mediaController = root.__cirkulMedia;
    if (mediaController?.slides?.length) {
      const slideIndex = mediaController.slides.findIndex((slide) => normalizeMediaId(slide.getAttribute('data-media-id')) === mediaId);
      if (slideIndex >= 0) {
        mediaController.setIndex(slideIndex);
      }
    }
  }

  function setAccordionState(container, expanded) {
    const toggle = container.querySelector(selectors.accordionToggle);
    const body = container.querySelector('[data-accordion-body]');
    if (!toggle || !body) return;

    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    body.hidden = !expanded;
    container.classList.toggle('is-open', expanded);

    const icon = toggle.querySelector('.cirkul-pdp__accordion-icon, .cirkul-pdp__faq-icon');
    if (icon) {
      icon.textContent = expanded ? '-' : '+';
    }
  }

  function initAccordion(root) {
    root.querySelectorAll(selectors.accordionToggle).forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const container =
          toggle.closest('.cirkul-pdp__accordion-item') ||
          toggle.closest('.cirkul-pdp__faq-card');
        if (!container) return;

        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        setAccordionState(container, !expanded);
      });
    });
  }

  function removeLegacyShopNow() {
    document.querySelectorAll('.cirkul-header__shopnow').forEach((node) => {
      node.remove();
    });
  }

  function initAddToCart(root, state) {
    root.querySelectorAll(selectors.addButton).forEach((button) => {
      button.addEventListener('click', async () => {
        const variantInput = root.querySelector(selectors.variantInput);
        const quantityInput = root.querySelector(selectors.quantityInput);
        if (!variantInput || !quantityInput) return;

        const variantId = Number(variantInput.value);
        const quantity = Number(quantityInput.value || 1);
        button.disabled = true;

        try {
          const response = await fetch(state.addUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              id: variantId,
              quantity,
            }),
          });

          if (!response.ok) throw new Error('add_failed');
          window.location.href = state.cartUrl;
        } catch (error) {
          button.disabled = false;
        }
      });
    });
  }

  function initProduct(root) {
    const stateNode = root.querySelector(selectors.state);
    if (!stateNode) return;

    const state = JSON.parse(stateNode.textContent || '{}');
    state.cartUrl = state.cartUrl || '/cart';
    state.addUrl = state.addUrl || '/cart/add.js';
    state.variants = Array.isArray(state.variants) ? state.variants : [];
    state.optionGroups = Array.isArray(state.optionGroups) ? state.optionGroups : [];
    state.quantity = 1;

    function getCurrentVariant() {
      return findVariant(state.variants, state.optionGroups) || state.variants[0];
    }

    function renderVariant() {
      const variant = getCurrentVariant();
      if (!variant) return;

      syncVariantInputs(root, variant.id);
      updatePrice(root, variant);
      updateOptionButtons(root, state.optionGroups);
      updateVariantMedia(root, variant, state);

      root.querySelectorAll(selectors.addButton).forEach((button) => {
        button.disabled = !variant.available;
      });
    }

    root.querySelectorAll(selectors.optionButton).forEach((button) => {
      button.addEventListener('click', () => {
        const optionIndex = Number(button.getAttribute('data-option-index'));
        const optionValue = button.getAttribute('data-option-value');
        if (!state.optionGroups[optionIndex]) return;
        state.optionGroups[optionIndex].value = optionValue;
        renderVariant();
      });
    });

    root.querySelectorAll(selectors.quantityButton).forEach((button) => {
      button.addEventListener('click', () => {
        const action = button.getAttribute('data-quantity-button');
        state.quantity = action === 'minus' ? Math.max(1, state.quantity - 1) : state.quantity + 1;
        syncQuantity(root, state.quantity);
      });
    });

    syncQuantity(root, state.quantity);
    renderVariant();
    syncBuyRowLayout(root);
    initMedia(root);
    initAccordion(root);
    initAddToCart(root, state);

    window.addEventListener('resize', () => {
      syncBuyRowLayout(root);
    });
  }

  removeLegacyShopNow();
  document.querySelectorAll(selectors.root).forEach(initProduct);
})();
